module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG51937568735ac8c287d60b8534db068f.51937568.png";